<template>
  <Form ref="form" :data="data" @save="onSave" :save_text="save_text" :edit="edit"/>
</template>

<script>
import Form from "@/domain/roles/components/Form.vue";

export default {
  name: "RoleForm",
  components: {Form},
  props: {
    data: {
      type: Object,
      required: true
    },
    save_text: {
      type: String,
      required: true
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  emits: ['save'],
  methods: {
    onSave(data) {
      this.$emit('save', data)
    },
    triggerSave() {
      this.$refs.form.onSave()
    },
    onReset() {
      this.$refs.form.onReset()
    }
  }
}
</script>